// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"88c1bb5a","648":"244aa721"}[chunkId] + ".chunk.js";
};